import { render, staticRenderFns } from "./OctTabBar.vue?vue&type=template&id=06640ba9&scoped=true&"
import script from "./OctTabBar.vue?vue&type=script&lang=js&"
export * from "./OctTabBar.vue?vue&type=script&lang=js&"
import style0 from "./OctTabBar.vue?vue&type=style&index=0&id=06640ba9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06640ba9",
  null
  
)

export default component.exports